import axios from 'axios'
import { getAccessToken } from './auth'

let host = window.location.hostname
host += host === 'localhost' ? ':8080' : ''
const baseURL = `${window.location.protocol}//${host}/api`

class Api {
  /**
   * @description make an axios request
   * @param {string} url
   * @param {string} method
   * @param {Object} requestData
   * @param {Object} customHeader
   */
  static buildRequest (url, method, requestData, customHeader, responseType) {
    const config = {
      baseURL,
      method,
      url,
      // The access token carries no email; the server uses this header only to label who
      // made something and to address notifications (server/src/config/auth.js).
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}`, 'X-User-Email': localStorage.getItem('email') || '' },
      validateStatus (status) {
        return (status >= 200) && (status < 500)
      }
    }
    method = method.toUpperCase()
    if (method === 'POST' || method === 'PATCH' || method === 'PUT' || method === 'DELETE') {
      config.data = requestData
    }
    if (method === 'GET' && requestData) {
      config.params = requestData
    }

    if (customHeader) {
      config.headers = Object.assign(config.headers, customHeader)
    }
    if (responseType) {
      config.responseType = responseType
    }

    return Api.makeRequest(config)
  }

  static makeRequest (config) {
    return axios(config)
  }
}

export default Api



//////////////////
// WEBPACK FOOTER
// ./utils/api.js
// module id = /R+W
// module chunks = 1